export function findArea(googleObj, country) {
  function removeAccents(inputString) {
    const accentMap = {
      а́: 'а',
      е́: 'е',
      ё́: 'ё',
      и́: 'и',
      о́: 'о',
      у́: 'у',
      ы́: 'ы',
      э́: 'э',
      ю́: 'ю',
      я́: 'я',
      А́: 'А',
      Е́: 'Е',
      Ё́: 'Ё',
      И́: 'И',
      О́: 'О',
      У́: 'У',
      Ы́: 'Ы',
      Э́: 'Э',
      Ю́: 'Ю',
      Я́: 'Я',
    }

    const accents = Object.keys(accentMap).join('|')
    const accentRegex = new RegExp(accents, 'g')

    return inputString.replace(accentRegex, (match) => accentMap[match])
  }

  let area = ''

  let isBritishCrown = googleObj.address_components.find((field) =>
    field.types.includes('country')
  )?.short_name

  if (country === 'US') {
    area = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_1') &&
        field.types.includes('political')
    )
  } else if (country === 'GR') {
    area = googleObj.address_components.find(
      (field) =>
        field.types.includes('administrative_area_level_3') ||
        field.types.includes('administrative_area_level_1') ||
        (field.types.includes('administrative_area_level_2') &&
          field.types.includes('political'))
    )
  } else if (isBritishCrown === 'IM') {
    area = googleObj.address_components.find((field) =>
      field.types.includes('country')
    )
  } else if (country === 'IT') {
    area = googleObj.address_components.find((field) =>
      field.types.includes('administrative_area_level_2')
    )
  } else {
    area = googleObj.address_components.find((field) =>
      field.types.includes('administrative_area_level_1')
    )

    if (!area) {
      area = googleObj.address_components.find((field) =>
        field.types.includes('administrative_area_level_2')
      )
    }

    if (!area) {
      area = googleObj.address_components.find((field) =>
        field.types.includes('administrative_area_level_3')
      )
    }
  }
  if (country === 'RU' && area) {
    area.long_name = removeAccents(area.long_name)
    area.short_name = removeAccents(area.short_name)
  }

  return area
}
